<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<div class="didactic">
  <header class="didactic--header">
    <div class="didactic--header__container">
      <h5 class="didactic--header__title">
        {{ 'newRequestDidactic' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    requestType="EDUCATIONAL"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</div>
